import React, { useMemo, useState } from "react";
import { Grid, Card, CardHeader, CardContent, Button } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import VehicleCard from "./VehicleCard";
import apiRequest from "apiRequest";

function VehicleHistory({ vehicles = [], title = "Vehicles", rowsPerPage = 4 }) {
  const [page, setPage] = useState(1);

  const { totalPages, visible } = useMemo(() => {
    const total = Math.max(1, Math.ceil((vehicles?.length || 0) / rowsPerPage));
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return { totalPages: total, visible: (vehicles || []).slice(start, end) };
  }, [vehicles, page, rowsPerPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) setPage(newPage);
  };

  return (
    <Card>
      <CardHeader title={title} />
      <CardContent>
        <Grid container spacing={2}>
          {visible.length === 0 ? (
            <Grid item xs={12}>
              <MDTypography>No vehicles found.</MDTypography>
            </Grid>
          ) : (
            visible.map((vehicle) => {
              // console.log("VehicleCard vehicle:", vehicle?.category?.image);
              // console.log("VehicleCard vehicle:", vehicle?.category?.name_en);
              const images = [
                vehicle.driving_licence_photo ? `${apiRequest.BASE_URL}${vehicle.driving_licence_photo}` : null,
                vehicle.insurance_photo ? `${apiRequest.BASE_URL}${vehicle.insurance_photo}` : null,
                vehicle.ownership_photo ? `${apiRequest.BASE_URL}${vehicle.ownership_photo}` : null,
                vehicle?.category?.image ? `${apiRequest.BASE_URL}/${vehicle?.category?.image}` : null
              ].filter(Boolean);

              const label = `Vehicle Information`;
              const title = `${vehicle.vehicle_make || ""} ${vehicle.vehicle_model || ""}`;
              const description = `Year: ${vehicle.vehicle_year || ""} | Plate: ${vehicle.number_plate || ""} | Body Type: ${vehicle.body_type || ""} | Status: ${vehicle.status || ""}`;
              const vehicleDataSubCategory = `${vehicle?.category?.name_en || ""}`;
              return (
                <Grid item xs={12} md={6} xl={3} key={vehicle.id}>
                  <VehicleCard
                    images={images}
                    label={label}
                    title={title}
                    description={description}
                    vehicleDataSubCategory={vehicleDataSubCategory}
                    action={{
                      type: "internal",
                      route: `/pages/vehicle/${vehicle.id}`,
                      color: "info",
                      label: "View Details",
                    }}
                  />
                </Grid>
              );
            })
          )}
        </Grid>

        <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
          <Button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
            Previous
          </Button>
          <MDTypography mx={2}>Page {page} of {totalPages}</MDTypography>
          <Button onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
            Next
          </Button>
        </MDBox>
      </CardContent>
    </Card>
  );
}

export default VehicleHistory;
